'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import * as FinderPropTypes from 'DesignData/propTypes/finder';
import ContextMenuItem from 'DesignData/models/ContextMenuItem';
import ContextMenuItemGroup from 'DesignData/models/ContextMenuItemGroup';
import { FINDER_FOLDER_RENAME } from 'DesignData/actions/ActionTypes';
import withNewAssetContextMenuOptions from 'DesignFinderUI/hocs/withNewAssetContextMenuOptions';
import { getFileTypeI18nKey } from 'DesignData/helpers/finderHelpers';
import withActionsModals from 'DesignFinderUI/components/modals/hoc/withActionsModals';
import withAssetActions from 'DesignFinderUI/hocs/withAssetActions';
import { compose } from 'redux';
const {
  FilePropTypes
} = FinderPropTypes;

class AssetContextMenu extends Component {
  constructor(props) {
    super(props);
    this.onContextMenu = this.onContextMenu.bind(this);
  }

  getI18nOptions() {
    const {
      i18nOptions,
      i18nKey,
      fileType
    } = this.props;
    return Object.assign({}, i18nOptions, {
      folderType: text(i18nKey('folderTypes.default')),
      fileType: fileType ? text(getFileTypeI18nKey(fileType), {
        count: 1
      }) : null
    });
  }

  createContextMenuItems() {
    const {
      actionHandlers,
      permissions,
      hasMarketplaceListing,
      i18nKey,
      isMultiSelected,
      assetActions,
      contextMenuOptions,
      fileId
    } = this.props;

    const buttonI18nKey = key => i18nKey(`contextMenu.${key}`);

    const {
      secondaryActions
    } = assetActions;
    const actions = [assetActions.primaryActions, secondaryActions.length && secondaryActions, assetActions.deleteAction].filter(Boolean);
    let newAssetActions = [];

    if (!(isMultiSelected || fileId)) {
      newAssetActions = contextMenuOptions;
    }
    /* Ensure you're returning a new array every time */


    return newAssetActions.concat(actions.map(actionsList => {
      const menuActions = actionsList.map(action => {
        const disabled = !permissions[action];
        const showMarketplaceListingWarning = action === FINDER_FOLDER_RENAME && hasMarketplaceListing;
        return new ContextMenuItem({
          label: text(buttonI18nKey(action), this.getI18nOptions()),
          callback: actionHandlers[action],
          disabled,
          tooltip: disabled && showMarketplaceListingWarning ? text('DesignFinderUI.actions.ThemeMarketplaceListingWarning') : null
        });
      });
      return new ContextMenuItemGroup({
        options: menuActions
      });
    }));
  }

  onContextMenu(e) {
    const {
      onOpenChange
    } = this.props;
    const menuItems = this.createContextMenuItems();
    this.props.openContextMenu(e, menuItems, {
      onOpenChange
    });
  }

  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "asset-context-menu-wrapper",
      onContextMenu: this.onContextMenu,
      children: this.props.children
    });
  }

}

AssetContextMenu.propTypes = {
  assetActions: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  actionHandlers: PropTypes.object.isRequired,
  children: PropTypes.node,
  hasMarketplaceListing: PropTypes.bool.isRequired,
  isMultiSelected: PropTypes.bool,
  i18nOptions: PropTypes.object.isRequired,
  onOpenChange: PropTypes.func,
  openContextMenu: PropTypes.func.isRequired,
  contextMenuOptions: PropTypes.arrayOf(PropTypes.instanceOf(ContextMenuItemGroup)).isRequired,
  i18nKey: PropTypes.func,
  fileType: FilePropTypes.fileType,
  fileId: FilePropTypes.fileId
};
AssetContextMenu.defaultProps = {
  assetActions: {},
  permissions: {},
  actionHandlers: {},
  isMultiSelected: false,
  isSelected: false,
  duplicateFolder: emptyFunction,
  isRenamingFolder: false,
  onCopyFolderToPortalClick: emptyFunction,
  onDeleteFolderClick: emptyFunction,
  toggleRenameFolder: emptyFunction,
  contextMenuOptions: [],
  i18nOptions: {}
};
export default compose(withNewAssetContextMenuOptions, withActionsModals, withAssetActions)(AssetContextMenu);